export default __webpack_public_path__ + "static/media/KakaoChatBottom.28dc1d40.png";